import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  price: {
    fontWeight: 'bold',
    fontSize: '14px'
  },
  pricesDailyItem: {
    marginBottom: '7px',
    '&:last-child': {
      marginBottom: 0
    }
  },
  checkInTime: {
    display: 'block',
    marginBottom: '3px'
  }
});

export default useStyles;
